// 22.01.19
import { reduxForm, FormSection } from "redux-form";
import * as React from "react";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { UserRoles, CaseType, CaseFormType } from "src/constants/api";
import {
    DateField,
    dateToTimestamp,
    DisableForRoles,
    CheckBoxField,
    FlexGridItem,
    FlexNumberField,
    FlexCurrencyInputField,
    FlexTextField,
    HideForRoles,
    required,
    SelectField,
    timestampToDate,
    validCurrency,
    validDate,
    maxLength200,
    maxLength100,
    maxLength50,
    TextArea,
} from "./form_utility";
import FormSelect from "../common/form/controls/select";
import {
    packingIntactData,
    tamperingData,
    sealIntactData,
} from "../../constants/dropdown";
import { change } from "redux-form";
import {
    actionSaveAttachmentData,
    actionDownloadAttachment,
    actionDeleteAttachment,
} from "src/actions/detail";
import AttachmentContainer from "src/components/common/attachment-container";
import { FORM_TYPE_SHIPMENT, FORM_ERROR_MESSAGE } from "src/constants/data.js";
import { getStringAfterSubstring, getStringBeforeSubstring } from "../../utils";
import { openToaster, closeToaster } from "src/actions/common";

const CURRENCY_LIST: any = (window as any).currencyList;

class ShipmentFormComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedCurrency: "",
            selectedPremiumCurrency: "",
            totalClaimCurrency: "",
            claimsValueFreightCurrency: "",
            upliftCurrency: "",
            deductibleUnderThePolicyCurrency: "",
            requiredFields: false,
        };
    }

    currencyCheck = (type: string, evt: any) => {
        const { dispatch } = this.props;
        switch (type) {
            case "freight":
                this.setState({ selectedCurrency: evt[0] });
                if (!evt[0]) {
                    dispatch(change("mainForm", "shipments[0].actualInsuredValues", ""));
                }
                return;
            case "premium":
                this.setState({ selectedPremiumCurrency: evt[0] });
                if (!evt[0]) {
                    dispatch(change("mainForm", "shipments[0].premium", ""));
                }
                return;
            case "totalClaim":
                this.setState({ totalClaimCurrency: evt[0] });
                if (!evt[0]) {
                    dispatch(
                        change("mainForm", "shipments[0].totalClaimsValuesSupplies", "")
                    );
                }
                return;
            case "claimsValueFreight":
                this.setState({ claimsValueFreightCurrency: evt[0] });
                if (!evt[0]) {
                    dispatch(change("mainForm", "shipments[0].claimsValueFreight", ""));
                }
                return;
            case "uplift":
                this.setState({ upliftCurrency: evt[0] });
                if (!evt[0]) {
                    dispatch(change("mainForm", "shipments[0].uplift", ""));
                }
                return;
            case "deductibleUnderThePolicy":
                this.setState({ deductibleUnderThePolicyCurrency: evt[0] });
                if (!evt[0]) {
                    dispatch(
                        change("mainForm", "shipments[0].deductibleUnderThePolicy", "")
                    );
                }
                return;
            case "totalValueOfLoss":
                this.setState({ totalValueOfLossCurrency: evt[0] });
                if (!evt[0]) {
                    dispatch(change("mainForm", "shipments[0].totalValueOfLoss", ""));
                }
                return;
            default:
                return;
        }
    };

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        const {
            values: { shipments },
        } = nextProps.mainForm.mainForm;
        if (shipments && shipments[0]) {
            if (shipments[0].actualInsuredValuesCurrency) {
                this.setState({
                    selectedCurrency: shipments[0].actualInsuredValuesCurrency,
                });
            }

            if (shipments[0].premiumCurrency) {
                this.setState({
                    selectedPremiumCurrency: shipments[0].premiumCurrency,
                });
            }

            if (shipments[0].totalClaimsValuesSuppliesCurrency) {
                this.setState({
                    totalClaimCurrency: shipments[0].totalClaimsValuesSuppliesCurrency,
                });
            }

            if (shipments[0].claimsValueFreightCurrency) {
                this.setState({
                    claimsValueFreightCurrency: shipments[0].claimsValueFreightCurrency,
                });
            }

            if (shipments[0].upliftCurrency) {
                this.setState({ upliftCurrency: shipments[0].upliftCurrency });
            }

            if (shipments[0].deductibleUnderThePolicyCurrency) {
                this.setState({
                    deductibleUnderThePolicyCurrency:
                        shipments[0].deductibleUnderThePolicyCurrency,
                });
            }

            if (shipments[0].totalValueOfLossCurrency) {
                this.setState({
                    totalValueOfLossCurrency: shipments[0].totalValueOfLossCurrency,
                });
            }
        }
    }

    public componentDidMount() {
        const { mainForm } = this.props;
        const { values } = mainForm.mainForm;

        if (
            values.hasOwnProperty("inCaseOfShipment") &&
            [1, 2, 3, 4].indexOf(values.inCaseOfShipment) >= 0
            && values.caseFormType !== CaseFormType.Incident
        ) {
            this.setState({
                requiredFields: true,
            });
        }
    }

    public componentWillUnmount() {
        const { closeToaster } = this.props;
        closeToaster();
    }

    render() {
        const {
            handleSubmit,
            saveAttachmentData,
            deleteAttachment,
            downloadAttachment,
            attachmentData,
            uniqueId,
            isNewCase,
            submitFailed,
            invalid,
            openToaster,
            closeToaster,
            isToasterVisible,
        } = this.props;

        const { requiredFields } = this.state;
        if (submitFailed && invalid) {
            openToaster(FORM_ERROR_MESSAGE, false);
        } else if (!invalid && isToasterVisible) {
            closeToaster();
        }
        // const isNewCase =
        //   this.props.route.location.pathname.indexOf("new/shipment") > -1;
        const disableForm = this.disableForm();
        return (
            <form
                onSubmit={handleSubmit}
                className={`${disableForm ? "disableForm" : ""}`}
            >
                <FormSection name="shipments[0]">
                    <Grid style={{ paddingTop: "25px" }} container={true} spacing={2}>
                        <FlexGridItem xs={12}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                {requiredFields ? (
                                    <FlexTextField
                                        name="description"
                                        label="Description of loss"
                                        validate={required}
                                        required={true}
                                    />
                                ) : (
                                    <FlexTextField
                                        name="description"
                                        label="Description of loss"
                                    />
                                )}
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                {requiredFields ? (
                                    <FormSelect
                                        name="tampering"
                                        label="Any signs of tampering"
                                        data={tamperingData}
                                        validate={required}
                                        required={true}
                                    />
                                ) : (
                                    <FormSelect
                                        name="tampering"
                                        label="Any signs of tampering"
                                        data={tamperingData}
                                    />
                                )}
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                {requiredFields ? (
                                    <FormSelect
                                        name="sealIntact"
                                        label="Was container seal intact"
                                        data={sealIntactData}
                                        validate={required}
                                        required={true}
                                    />
                                ) : (
                                    <FormSelect
                                        name="sealIntact"
                                        label="Was container seal intact"
                                        data={sealIntactData}
                                    />
                                )}
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                {requiredFields ? (
                                    <FormSelect
                                        name="packingIntact"
                                        label="Was packing intact"
                                        data={packingIntactData}
                                        validate={required}
                                        required={true}
                                    />
                                ) : (
                                    <FormSelect
                                        name="packingIntact"
                                        label="Was packing intact"
                                        data={packingIntactData}
                                    />
                                )}
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                {requiredFields ? (
                                    <FlexTextField
                                        name="containerNo"
                                        label="Container No(s)"
                                        validate={[required, maxLength200]}
                                        required={true}
                                    />
                                ) : (
                                    <FlexTextField
                                        name="containerNo"
                                        label="Container No(s)"
                                        validate={[maxLength200]}
                                    />
                                )}
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="sealNo"
                                    label="Seal No(s)"
                                    validate={[maxLength200]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <DateField
                                    name="dateReceivedInCountry"
                                    label="Date received in country"
                                    format={timestampToDate}
                                    normalize={dateToTimestamp}
                                    validate={[validDate]}
                                    required={requiredFields}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                {requiredFields ? (
                                    <FlexTextField
                                        name="quantity"
                                        label="Damage/Missing/Short shipped quantity"
                                        validate={[required, maxLength100]}
                                        required={true}
                                    />
                                ) : (
                                    <FlexTextField
                                        name="quantity"
                                        label="Damage/Missing/Short shipped quantity"
                                        validate={[maxLength100]}
                                    />
                                )}
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <DateField
                                    name="customsClearanceDate"
                                    label="Customs clearance date"
                                    format={timestampToDate}
                                    normalize={dateToTimestamp}
                                    validate={[validDate]}
                                    required={requiredFields}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[
                                    UserRoles.FMC,
                                    UserRoles.UNICEF,
                                    UserRoles.Solution_Owner,
                                    UserRoles.Solution_Team,
                                ]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="forwarderReference"
                                    label="Forwarder reference"
                                    validate={[maxLength100]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles
                                roles={[
                                    UserRoles.Partner,
                                    UserRoles.UNICEF,
                                    UserRoles.Solution_Owner,
                                    UserRoles.Solution_Team,
                                ]}
                            >
                                <DisableForRoles
                                    roles={[UserRoles.FMC]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <SelectField
                                        name="totalValueOfLossCurrency"
                                        label="Currency"
                                        onChange={this.currencyCheck.bind(null, "totalValueOfLoss")}
                                        style={{
                                            width: "100%",
                                        }}
                                    >
                                        <option value={undefined} />
                                        {CURRENCY_LIST.map((item: any) => (
                                            <option key={item.value} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </SelectField>
                                </DisableForRoles>
                            </HideForRoles>
                            <HideForRoles
                                roles={[
                                    UserRoles.Partner,
                                    UserRoles.UNICEF,
                                    UserRoles.Solution_Owner,
                                    UserRoles.Solution_Team,
                                ]}
                            >
                                <DisableForRoles
                                    roles={[UserRoles.FMC]}
                                    isnewcase={isNewCase}
                                    isDisableCheck={true}
                                    disablecheck={this.state.totalValueOfLossCurrency}
                                    disableField={disableForm}
                                >
                                    <FlexCurrencyInputField
                                        style={{ width: "80%" }}
                                        name="totalValueOfLoss"
                                        label="Total value of loss"
                                        validate={[validCurrency, maxLength50]}
                                        iscurrency={true}
                                        selected={this.state.totalValueOfLossCurrency}
                                        disabled={!this.state.totalValueOfLossCurrency}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="salesOrderNo"
                                    label="Sales order no"
                                    validate={[maxLength50]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles roles={[UserRoles.FMC]} isnewcase={isNewCase}>
                                <FlexTextField
                                    name="freightForwarderName"
                                    label="Freight forwarder name"
                                    validate={[maxLength200]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="actualFreightValue"
                                    label="Actual/Estimated freight value"
                                    validate={[maxLength50]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="shipmentValue"
                                    label="Shipment value"
                                    validate={[maxLength50]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[
                                    UserRoles.FMC,
                                    UserRoles.Solution_Owner,
                                    UserRoles.Solution_Team,
                                ]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <DateField
                                    name="bldate"
                                    label="B/L date"
                                    format={timestampToDate}
                                    normalize={dateToTimestamp}
                                    validate={validDate}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="blwayBillAwb"
                                    label="B/L, Waybill No's, AWB"
                                    validate={[maxLength200]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="vesselIdflightNo"
                                    label="Vessel ID/Flight No"
                                    validate={[maxLength200]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="meansOfTransport"
                                    label="Means of transport"
                                    validate={[maxLength200]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="transportDepartureCountry"
                                    label="Transport departure country"
                                    validate={[maxLength200]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="portAirportOfDeparture"
                                    label="Port/Airport of departure"
                                    validate={[maxLength200]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="transportDestinationCountry"
                                    label="Transport destination country"
                                    validate={[maxLength200]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="portAirportOfDestination"
                                    label="Port/Airport of destination"
                                    validate={[maxLength200]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="originIncoterm"
                                    label="Origin INCOTERM"
                                    validate={[maxLength50]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="destinationIncoterm"
                                    label="Destination INCOTERM"
                                    validate={[maxLength50]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <DateField
                                    name="transportStart"
                                    label="Transport start"
                                    format={timestampToDate}
                                    normalize={dateToTimestamp}
                                    validate={validDate}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <DateField
                                    name="transportEnd"
                                    label="Transport end"
                                    format={timestampToDate}
                                    normalize={dateToTimestamp}
                                    validate={validDate}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="shipmentTotalQuantity"
                                    label="Shipment total quantity"
                                    validate={[maxLength50]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles
                                roles={[
                                    UserRoles.Partner,
                                    UserRoles.UNICEF,
                                    UserRoles.Solution_Owner,
                                    UserRoles.Solution_Team,
                                ]}
                            >
                                <DisableForRoles
                                    roles={[UserRoles.FMC]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <FlexTextField
                                        name="insurancePostingReference"
                                        label="Insurance posting reference"
                                        validate={[maxLength50]}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <DateField
                                    name="reportedOn"
                                    label="Reported on"
                                    format={timestampToDate}
                                    normalize={dateToTimestamp}
                                    validate={validDate}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <DisableForRoles
                                roles={[UserRoles.FMC]}
                                isnewcase={isNewCase}
                                disableField={disableForm}
                            >
                                <FlexTextField
                                    name="totalNumberOfPackages"
                                    label="Total number of packages"
                                    validate={[maxLength50]}
                                />
                            </DisableForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles
                                roles={[
                                    UserRoles.Partner,
                                    UserRoles.UNICEF,
                                    UserRoles.Solution_Owner,
                                    UserRoles.Solution_Team,
                                ]}
                            >
                                <DisableForRoles
                                    roles={[UserRoles.FMC]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <SelectField
                                        name="actualInsuredValuesCurrency"
                                        label="Currency"
                                        onChange={this.currencyCheck.bind(null, "freight")}
                                        style={{
                                            width: "100%",
                                        }}
                                    >
                                        <option value={undefined} />
                                        {CURRENCY_LIST.map((item: any) => (
                                            <option key={item.value} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </SelectField>
                                </DisableForRoles>
                            </HideForRoles>
                            <HideForRoles
                                roles={[
                                    UserRoles.Partner,
                                    UserRoles.UNICEF,
                                    UserRoles.Solution_Owner,
                                    UserRoles.Solution_Team,
                                ]}
                            >
                                <DisableForRoles
                                    roles={[UserRoles.FMC]}
                                    isnewcase={isNewCase}
                                    isDisableCheck={true}
                                    disablecheck={this.state.selectedCurrency}
                                    disableField={disableForm}
                                >
                                    <FlexCurrencyInputField
                                        style={{ width: "80%" }}
                                        name="actualInsuredValues"
                                        label="Actual/Estimated insured values"
                                        validate={[validCurrency, maxLength100]}
                                        iscurrency={true}
                                        selected={this.state.selectedCurrency}
                                        disabled={!this.state.selectedCurrency}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={6}>
                            <HideForRoles
                                roles={[
                                    UserRoles.Partner,
                                    UserRoles.UNICEF,
                                    UserRoles.Solution_Owner,
                                    UserRoles.Solution_Team,
                                ]}
                            >
                                <DisableForRoles
                                    roles={[UserRoles.FMC]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <SelectField
                                        name="premiumCurrency"
                                        label="Currency"
                                        onChange={this.currencyCheck.bind(null, "premium")}
                                        style={{
                                            width: "100%",
                                        }}
                                    >
                                        <option value={undefined} />
                                        {CURRENCY_LIST.map((item: any) => (
                                            <option key={item.value} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </SelectField>
                                </DisableForRoles>
                            </HideForRoles>
                            <HideForRoles
                                roles={[
                                    UserRoles.Partner,
                                    UserRoles.UNICEF,
                                    UserRoles.Solution_Owner,
                                    UserRoles.Solution_Team,
                                ]}
                            >
                                <DisableForRoles
                                    roles={[UserRoles.FMC]}
                                    isnewcase={isNewCase}
                                    isDisableCheck={true}
                                    disablecheck={this.state.selectedPremiumCurrency}
                                    disableField={disableForm}
                                >
                                    <FlexCurrencyInputField
                                        style={{ width: "80%" }}
                                        name="premium"
                                        label="Premium"
                                        validate={[validCurrency, maxLength100]}
                                        iscurrency={true}
                                        selected={this.state.selectedPremiumCurrency}
                                        disabled={!this.state.selectedPremiumCurrency}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>

                        <FlexGridItem xs={12}>
                            <FlexGridItem xs={6}>
                                <DisableForRoles
                                    roles={[UserRoles.FMC]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <FlexNumberField
                                        name="quantityLostPerMaterialLevel"
                                        label="Quantity lost per material level"
                                        validate={[maxLength100]}
                                    />
                                </DisableForRoles>
                            </FlexGridItem>
                            <FlexGridItem xs={6}>
                                <DisableForRoles
                                    roles={[UserRoles.FMC]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <SelectField
                                        name="totalClaimsValuesSuppliesCurrency"
                                        label="Currency"
                                        onChange={this.currencyCheck.bind(null, "totalClaim")}
                                        style={{
                                            width: "100%",
                                        }}
                                    >
                                        <option value={undefined} />
                                        {CURRENCY_LIST.map((item: any) => (
                                            <option key={item.value} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </SelectField>
                                </DisableForRoles>
                                <DisableForRoles
                                    roles={[UserRoles.FMC]}
                                    isnewcase={isNewCase}
                                    isDisableCheck={true}
                                    disablecheck={this.state.totalClaimCurrency}
                                    disableField={disableForm}
                                >
                                    <FlexCurrencyInputField
                                        style={{ width: "80%" }}
                                        name="totalClaimsValuesSupplies"
                                        label="Total claims value supplies"
                                        validate={[validCurrency, maxLength50]}
                                        iscurrency={true}
                                        selected={this.state.totalClaimCurrency}
                                        disabled={!this.state.totalClaimCurrency}
                                    />
                                </DisableForRoles>
                            </FlexGridItem>
                        </FlexGridItem>

                        <FlexGridItem xs={12}>
                            <FlexGridItem xs={6}>
                                <DisableForRoles
                                    roles={[UserRoles.FMC]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <SelectField
                                        name="claimsValueFreightCurrency"
                                        label="Currency"
                                        onChange={this.currencyCheck.bind(
                                            null,
                                            "claimsValueFreight"
                                        )}
                                        style={{
                                            width: "100%",
                                        }}
                                    >
                                        <option value={undefined} />
                                        {CURRENCY_LIST.map((item: any) => (
                                            <option key={item.value} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </SelectField>
                                </DisableForRoles>
                                <DisableForRoles
                                    roles={[UserRoles.FMC]}
                                    isnewcase={isNewCase}
                                    isDisableCheck={true}
                                    disablecheck={this.state.claimsValueFreightCurrency}
                                    disableField={disableForm}
                                >
                                    <FlexCurrencyInputField
                                        style={{ width: "80%" }}
                                        name="claimsValueFreight"
                                        label="Claims value freight"
                                        validate={[validCurrency, maxLength50]}
                                        iscurrency={true}
                                        selected={this.state.claimsValueFreightCurrency}
                                        disabled={!this.state.claimsValueFreightCurrency}
                                    />
                                </DisableForRoles>
                            </FlexGridItem>
                            <FlexGridItem xs={6}>
                                <HideForRoles
                                    roles={[
                                        UserRoles.Partner,
                                        UserRoles.UNICEF,
                                        UserRoles.Solution_Owner,
                                        UserRoles.Solution_Team,
                                    ]}
                                >
                                    <DisableForRoles
                                        roles={[UserRoles.FMC]}
                                        isnewcase={isNewCase}
                                        disableField={disableForm}
                                    >
                                        <SelectField
                                            name="upliftCurrency"
                                            label="Currency"
                                            onChange={this.currencyCheck.bind(null, "uplift")}
                                            style={{
                                                width: "100%",
                                            }}
                                        >
                                            <option value={undefined} />
                                            {CURRENCY_LIST.map((item: any) => (
                                                <option key={item.value} value={item.value}>
                                                    {item.label}
                                                </option>
                                            ))}
                                        </SelectField>
                                    </DisableForRoles>
                                </HideForRoles>
                                <HideForRoles
                                    roles={[
                                        UserRoles.Partner,
                                        UserRoles.UNICEF,
                                        UserRoles.Solution_Owner,
                                        UserRoles.Solution_Team,
                                    ]}
                                >
                                    <DisableForRoles
                                        roles={[UserRoles.FMC]}
                                        isnewcase={isNewCase}
                                        isDisableCheck={true}
                                        disablecheck={this.state.upliftCurrency}
                                        disableField={disableForm}
                                    >
                                        <FlexCurrencyInputField
                                            style={{ width: "80%" }}
                                            name="uplift"
                                            label="10% uplift"
                                            validate={[validCurrency, maxLength50]}
                                            iscurrency={true}
                                            selected={this.state.upliftCurrency}
                                            disabled={!this.state.upliftCurrency}
                                        />
                                    </DisableForRoles>
                                </HideForRoles>
                            </FlexGridItem>
                        </FlexGridItem>

                        <FlexGridItem xs={12}>
                            <FlexGridItem xs={6}>
                                <HideForRoles
                                    roles={[
                                        UserRoles.Partner,
                                        UserRoles.UNICEF,
                                        UserRoles.Solution_Owner,
                                        UserRoles.Solution_Team,
                                    ]}
                                >
                                    <DisableForRoles
                                        roles={[UserRoles.FMC]}
                                        isnewcase={isNewCase}
                                        disableField={disableForm}
                                    >
                                        <SelectField
                                            name="deductibleUnderThePolicyCurrency"
                                            label="Currency"
                                            onChange={this.currencyCheck.bind(
                                                null,
                                                "deductibleUnderThePolicy"
                                            )}
                                            style={{
                                                width: "100%",
                                            }}
                                        >
                                            <option value={undefined} />
                                            {CURRENCY_LIST.map((item: any) => (
                                                <option key={item.value} value={item.value}>
                                                    {item.label}
                                                </option>
                                            ))}
                                        </SelectField>
                                    </DisableForRoles>
                                </HideForRoles>
                                <HideForRoles
                                    roles={[
                                        UserRoles.Partner,
                                        UserRoles.UNICEF,
                                        UserRoles.Solution_Owner,
                                        UserRoles.Solution_Team,
                                    ]}
                                >
                                    <DisableForRoles
                                        roles={[UserRoles.FMC]}
                                        isnewcase={isNewCase}
                                        isDisableCheck={true}
                                        disablecheck={this.state.deductibleUnderThePolicyCurrency}
                                        disableField={disableForm}
                                    >
                                        <FlexCurrencyInputField
                                            style={{ width: "80%" }}
                                            name="deductibleUnderThePolicy"
                                            label="Deductible under the policy"
                                            validate={[validCurrency, maxLength50]}
                                            iscurrency={true}
                                            selected={this.state.deductibleUnderThePolicyCurrency}
                                            disabled={!this.state.deductibleUnderThePolicyCurrency}
                                        />
                                    </DisableForRoles>
                                </HideForRoles>
                            </FlexGridItem>
                        </FlexGridItem>
                        <FlexGridItem xs={12}>
                            <TextArea
                                name="shipmentComments"
                                label="Comments"
                                disabled={disableForm}
                            />
                        </FlexGridItem>
                        <FlexGridItem xs={12}>
                            <HideForRoles roles={[UserRoles.FMC, UserRoles.Partner]}>
                                <DisableForRoles
                                    roles={[
                                        UserRoles.UNICEF,
                                        UserRoles.Solution_Owner,
                                        UserRoles.Solution_Team,
                                    ]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <React.Fragment>
                                        <div style={{ paddingLeft: "12px", paddingTop: "12px" }}>
                                            <CheckBoxField name="psb" label="PSB" />
                                        </div>
                                        <p>
                                            PSB - Confirm that for all cases of shortage/loss/damage
                                            the records in Vision has been adjusted and the items are
                                            moved to the PSB bin (099) in Vision.
                                        </p>
                                    </React.Fragment>
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={12}>
                            <HideForRoles roles={[UserRoles.FMC, UserRoles.Partner]}>
                                <DisableForRoles
                                    roles={[]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <FlexTextField
                                        name="psbcomments"
                                        label="If No please comment"
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                        </FlexGridItem>
                        <FlexGridItem xs={12}>
                            <HideForRoles
                                roles={[
                                    UserRoles.Partner,
                                    UserRoles.UNICEF,
                                    UserRoles.Solution_Owner,
                                    UserRoles.Solution_Team,
                                ]}
                            >
                                <DisableForRoles
                                    roles={[UserRoles.FMC]}
                                    isnewcase={isNewCase}
                                    disableField={disableForm}
                                >
                                    <FlexTextField
                                        name="recoveryValue"
                                        label="Recovery value"
                                        validate={[maxLength50]}
                                    />
                                </DisableForRoles>
                            </HideForRoles>
                            {/* <DisableForRoles roles={[UserRoles.FMC]}>  
                <FlexTextField name="attachments" label="Attachments" />
              </DisableForRoles>   */}
                        </FlexGridItem>
                        {/* <FlexGridItem xs={12}> */}
                        {/* The field attachments is to be set when attachments are added. */}
                        {/* <FlexTextField name="attachments" label="Attach evidence" />*/}
                        {/* <DisableForRoles
                roles={[UserRoles.FMC]}
                isnewcase={isNewCase}
              >
                <Button variant="contained" color="primary" type="button">
                  Attach files
                </Button>
              </DisableForRoles>
            </FlexGridItem> */}
                        <DisableForRoles
                            roles={[UserRoles.FMC]}
                            isnewcase={isNewCase}
                            disableField={disableForm}
                        >
                            <AttachmentContainer
                                label="Attachments"
                                uniqueId={uniqueId}
                                onSave={saveAttachmentData}
                                attachment={attachmentData}
                                download={downloadAttachment}
                                remove={deleteAttachment}
                                type={FORM_TYPE_SHIPMENT}
                                {...this.props}
                            />
                        </DisableForRoles>
                    </Grid>
                </FormSection>
            </form>
        );
    }

    private disableForm = () => {
        const {
            caseData,
            currentRoleId,
            allowEdit,
            isNewCase,
            mainForm,
            isLockForEdit,
            currentUsername,
        } = this.props;
        let disableForm = false;
        const formValues = mainForm.mainForm.values;
        if (!allowEdit) {
            disableForm = true;
        } else if (!isNewCase && caseData) {
            if (
                currentRoleId === UserRoles.QMU &&
                formValues.caseType === CaseType.Claim
            ) {
                disableForm = true;
            } else if (
                currentRoleId === UserRoles.INS &&
                formValues.caseType === CaseType.Complaint
            ) {
                disableForm = true;
            } else if (currentRoleId === UserRoles.UNICEF && isLockForEdit) {
                disableForm = true;
            } else if (
                currentRoleId === UserRoles.Solution_Owner ||
                currentRoleId === UserRoles.Solution_Team
            ) {
                // Get username who created the case
                let createdBy = mainForm.mainForm.values.createdBy;
                createdBy = getStringAfterSubstring(createdBy, "(");
                createdBy = getStringBeforeSubstring(createdBy, ")").trim();

                if (currentUsername !== createdBy || isLockForEdit) {
                    disableForm = true;
                }
            }
        }

        return disableForm;
    };
}

// mainForm is the name of the form object for the Redux form state store.
// enableReinitialize enables changes to initial data to render.
// keepDirtyOnReinitialize enables to keep edited data on reinitialize.
// destroyOnUnmount enables that data is kept when changing tabs.
const ShipmentForm = reduxForm({
    enableReinitialize: true,
    form: "mainForm",
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
    // @ts-ignore
})(ShipmentFormComponent);

function mapStateToProps(state: any, ownProps: any) {
    return {
        mainForm: state.form,
        route: state.routing,
        attachmentData: state.detail.attachmentDataShipment,
        caseData: state.detail.caseData,
        allowEdit: state.detail.allowEdit,
        currentUser: state.home.currentUser,
        currentUsername: state.detail.currentUsername,
        isLockForEdit: state.detail.isLockForEdit,
        isToasterVisible: state.common.isToasterVisible,
    };
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        saveAttachmentData: (
            file: any,
            uploadedBy: any,
            uniqueId: any,
            prevAttachmentData: any,
            type: string
        ) =>
            dispatch(
                actionSaveAttachmentData(
                    file,
                    uploadedBy,
                    uniqueId,
                    prevAttachmentData,
                    type
                )
            ),
        downloadAttachment: (fileId: any) =>
            dispatch(actionDownloadAttachment(fileId)),
        deleteAttachment: (fileId: any, attachmentData: any, type: string) =>
            dispatch(actionDeleteAttachment(fileId, attachmentData, type)),
        openToaster: (message: string, success: boolean) =>
            dispatch(openToaster(message, success)),
        closeToaster: () => dispatch(closeToaster()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentForm);
